import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// amplify
import { Auth, API } from 'aws-amplify'
import { listCauses, listSkills } from '../../graphql/queries'

// models
import { Cause, Skill } from '../../../API'

interface CoreState {
    skills: Skill[] | null,
    causes: Cause[] | null
}

const initialState: CoreState = {
    skills: [],
    causes: []
}

export const getSkills: any = createAsyncThunk(
    'core/getSkills',
    async (props: any, { dispatch }) => {
        try {
            const { data }: any = await API.graphql({
                query: listSkills,
                variables: {

                }
            })

            return data.listSkills.items
        } catch (err) {
            console.error(err)
        }
    }
)

export const getCauses: any = createAsyncThunk(
    'core/getCauses',
    async (props: any, { dispatch }) => {
        try {
            const { data }: any = await API.graphql({
                query: listCauses,
                variables: {

                }
            })

            return data.listCauses.items
        } catch (err) {
            console.error(err)
        }
    }
)

export const coreSlice = createSlice({
    name: 'core',
    initialState,
    reducers: {
        clearLocalCoreData: (state) => {
            state.skills = null
            state.causes = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSkills.fulfilled, (state, { payload }) => {
            state.skills = payload
        })
        builder.addCase(getCauses.fulfilled, (state, { payload }) => {
            state.causes = payload
        })
    }
})

export const { clearLocalCoreData } = coreSlice.actions
export default coreSlice.reducer